import styled from 'styled-components';
import css from '@styled-system/css';
// import { Box } from 'reflexbox/styled-components';

import Box from 'legacy/components/box';

const Pill = styled(Box)(
  css({
    display: 'inline-block',
    mt: 3,
    px: 3,
    py: 1,
    bg: 'rgba(138, 218, 213, 0.5)',
    borderRadius: 30,
    fontSize: 0,
    fontWeight: 600,
    lineHeight: 1,
    color: 'blue',
    textTransform: 'uppercase',
  })
);

export default Pill;
